module.exports = __webpack_public_path__ + "static/img/3658_phase_function_Paper_Points.a0cb86a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3658_phase_function_Paper_Points.png
// module id = 4CMd
// module chunks = 0